import React, {Component} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

// @mui/icons-material
import {NotificationsActive} from "@mui/icons-material";

// core components
import BeatLoaderRegular from "components/loaders/BeatLoaderRegular";
import CancellationReasonDialog from "views/picking/components/cancellationReasonDialog";
import PriceDetails from 'views/picking/components/PriceDetails';
import TableCard from "./components/tableCard";
import OrderActivities from "./components/OrderActivities";
import AddInternalNoteButton from "views/quote/components/show/notes/components/AddInternalNoteButton";
import ModalAddInternalNote from "./components/ModalAddInternalNote";
import Snackbar from "components/snackbar/snackbar";

// styles
import showStyle from "assets/jss/views/picking/order/showStyle";

// actions
import {list, reset} from "actions/lineItem/list";
import {
    cancellationReason,
    reset as resetUpdateOrder
} from "actions/order/update";
import {list as noteList, reset as noteReset} from "actions/order/note/list";
import {list as lineItemActivityList, reset as lineItemActivityReset} from "actions/order/lineItemActivity/list";
import {create as createNote} from "actions/order/note/create";
import {resetUpdate} from "actions/lineItem/update";
import {list as organizationShippingMethodsList} from "api/shippingMethod/list";
// helpers
import abort from "utils/abort";
import {Authorizations, hasAuthorization} from "utils/authorizations";

// context
import {OrderContext} from "contexts/OrderContext";
import {withStyles} from "@mui/styles";

class Show extends Component {
    static propTypes = {
        error: PropTypes.string,
        list: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            createErrorNotification: true,
            modalOpen: false,
            trackingNumber: null,
            runner: false,
            addNoteOpen: false,
            organizationShippingMethods: [],
            cancellationReasonDialog: false,
            transitionActions: null,
            selectedItem: null,
            lineItemSelectedIds: [],
            waitingTimeBeforeRefreshingList: false,
            selectedShipment: null,
            shouldResetSelection: false,
        };
    };

    // because we don't want to use redux to trigger a refresh
    refreshOrder(waitingTime = 0) {
        this.setState({
            waitingTimeBeforeRefreshingList: true,
            shouldResetSelection: true,
            lineItemSelectedIds: [],
            selectedShipment: null,
        });
        setTimeout(() => {
            this.props.list(decodeURIComponent(`order.id=${this.props.match.params.id}&pagination=true&itemsPerPage=9999&page=1&order[name]=asc`));
            this.props.noteList(decodeURIComponent(`order.id=${this.props.match.params.id}&order[createdAt]=desc`));
            this.props.lineItemActivityList(decodeURIComponent(`order.id=${this.props.match.params.id}&order[createdAt]=desc`));
            this.props.resetUpdate();
            this.props.resetUpdateOrder();
            this.setState({
                waitingTimeBeforeRefreshingList: false,
                shouldResetSelection: false,
            });
        }, waitingTime);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({createErrorNotification: true});
        if ((this.props.updateSuccessOrder !== nextProps.updateSuccessOrder) || this.props.updateSuccessLineItem !== nextProps.updateSuccessLineItem) {
            this.refreshOrder();
        }

        if (this.props.noteCreated !== nextProps.noteCreated) {
            nextProps.noteList(decodeURIComponent(`order.id=${this.props.match.params.id}&order[createdAt]=desc`));
        }
    }

    componentDidMount() {
        this.props.list(decodeURIComponent(`order.id=${this.props.match.params.id}&pagination=true&itemsPerPage=9999&page=1&order[name]=asc`));
        this.props.noteList(decodeURIComponent(`order.id=${this.props.match.params.id}&order[createdAt]=desc`));
        this.props.lineItemActivityList(decodeURIComponent(`order.id=${this.props.match.params.id}&order[createdAt]=desc`));

        organizationShippingMethodsList().then((res) => {
            this.setState({
                organizationShippingMethods: res
            })
        })
    }

    componentWillUnmount() {
        this.props.reset();
        this.props.noteReset();
        this.props.lineItemActivityReset();
        abort.abortRequests();
    };

    toggleModalWaybillSelector = () => {
        this.setState({
            modalOpen: !this.state.modalOpen,
        });
    }

    handleMoreClick = () => {
        this.setState(state => ({
            open: !state.open,
        }));
    };

    confirmCancellationAction(reason, unavailableDays = null) { const {selectedItem} = this.state;
        this.props.cancellationReason(selectedItem, reason, unavailableDays);

        this.closeCancellationReasonDialog();
    }

    openCancellationDialogByTransitionAndItem(order, transitionActions) {
        this.setState({
            selectedItem: order,
            transitionActions: transitionActions,
            cancellationReasonDialog: true
        })
    }

    closeCancellationReasonDialog() {
        this.setState({
            cancellationReasonDialog: false,
            selectedItem: null,
            transitionActions: null
        })
    }

    setLineItemSelectedIds = (lineItemIds) => {
        this.setState({
            lineItemSelectedIds: lineItemIds,
        })
    }

    setSelectedShipment = (shipment) => {
        this.setState({
            selectedShipment: shipment
        })
    }

    render() {
        const {classes, retrieved, loading} = this.props;

        const hasErrors = this.props.error || this.props.updateErrorOrder;
        const order = retrieved && retrieved["hydra:member"][0].order;

        const handleClickOpenAddNote = () => {
            this.setState(state => ({addNoteOpen: true}));
        };

        const handleCloseAddNote = () => {
            this.setState(state => ({addNoteOpen: false}));
        };

        const handleAddNote = (note) => {
            this.props.createNote({content: note, order: `/orders/${order.id}`, member: `/members/${this.props.member.id}`, type: 'internal_note'});
            handleCloseAddNote();
        };

        const isRefreshing = loading && retrieved;

        const loaderOverlay = isRefreshing ? (
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                zIndex: 1000,
                borderRadius: '4px'
            }}>
                <BeatLoaderRegular loading={loading} />
            </div>
        ) : null;

        if (loading && !retrieved) {
            return (
                <div className={classes.containerWithSidebar}>
                    <div style={{display: 'flex', justifyContent: 'center', marginTop: '50px', width: '100%'}}>
                        <BeatLoaderRegular loading={loading} />
                    </div>
                </div>
            )
        }

        return (
            <div className={classes.containerWithSidebar}>
                {hasErrors && (
                    <Snackbar
                        open={this.state.createErrorNotification}
                        close
                        closeNotification={() => this.setState({createErrorNotification: false})}
                        place={"bl"}
                        color={"danger"}
                        icon={function () {
                            return <NotificationsActive/>
                        }}
                        message={this.props.error}
                    />
                )}
                <div className={classes.container}>
                    {loaderOverlay}

                    <TableCard 
                        order={order}
                        state={this.state}
                        openCancellationDialogByTransitionAndItem={(order, transitionActions) => this.openCancellationDialogByTransitionAndItem(order, transitionActions)}
                        toggleModalWaybillSelector={this.toggleModalWaybillSelector}
                        refreshOrder={(waitingTime) => this.refreshOrder(waitingTime)}
                        match={this.props.match}
                        setSelectedShipment={this.setSelectedShipment}
                        setLineItemSelectedIds={this.setLineItemSelectedIds}
                        shouldResetSelection={this.state.shouldResetSelection}
                        isWmsEnabled={this.props.currentOrganization?.wms}
                    />
                    <div className={classes.priceDetailsContainer}>
                        {loaderOverlay}
                        <PriceDetails
                            lineItems={this.props.retrieved && this.props.retrieved['hydra:member']}
                            currentOrganization={this.props.currentOrganization}
                            authorizations={this.props.authorizations}
                        />
                    </div>
                    {!this.props.noteLoading && !this.props.lineItemActivityLoading &&
                        <div className={classes.notesSection}>
                            {!hasAuthorization(this.props.authorizations, Authorizations.PICKING_READ_ONLY) &&
                                <div className={classes.addNoteContainer}>
                                    <ModalAddInternalNote
                                        open={this.state.addNoteOpen}
                                        onClose={handleCloseAddNote}
                                        onSubmit={handleAddNote}
                                    />
                                    <AddInternalNoteButton onClick={handleClickOpenAddNote} />
                                </div>
                            }

                            <OrderActivities
                                classes={classes}
                                notes={this.props.noteRetrieved?.["hydra:member"] ?? []}
                                lineItemActivities={this.props.lineItemActivityRetrieved?.["hydra:member"] ?? []}
                                order={order}
                            />
                        </div>
                    }
                </div>
                <OrderContext.Provider value={{
                    closeCancellationReasonDialog: () => this.closeCancellationReasonDialog(),
                    confirmCancellationAction: (selectedReason, daysCount) => {
                        this.confirmCancellationAction(selectedReason, daysCount)
                    },
                    isCancellationReasonDialogOpen: this.state.cancellationReasonDialog,
                    transitionActions: this.state.transitionActions,
                    isOrderAllowed: true,
                    isItemAllowed: false,
                    status: this.state.selectedItem?.status
                }}>
                    <CancellationReasonDialog />
                </OrderContext.Provider>
            </div>
        );
    }

}

const mapStateToProps = state => {
    return {
        retrieved: state.lineItem.list.retrieved,
        loading: state.lineItem.list.loading,
        error: state.order.list.error,
        noteRetrieved: state.note.list.retrieved,
        noteLoading: state.note.list.loading,
        noteCreated: state.note.create.created,
        lineItemActivityRetrieved: state.lineItemActivity.list.retrieved,
        lineItemActivityLoading: state.lineItemActivity.list.loading,
        updateSuccessOrder: state.order.update.success,
        updateErrorOrder: state.order.update.error,
        updateSuccessLineItem: state.lineItem.update.success,
        member: state.authentication.member,
        authorizations: state.authentication.authorizations,
        currentOrganization: state.currentOrganization.retrieved ?? null,
    };
};

const mapDispatchToProps = dispatch => ({
    list: params => dispatch(list(params)),
    noteList: params => dispatch(noteList(params)),
    lineItemActivityList: params => dispatch(lineItemActivityList(params)),
    createNote: values => dispatch(createNote(values)),
    reset: () => dispatch(reset()),
    noteReset: () => dispatch(noteReset()),
    lineItemActivityReset: () => dispatch(lineItemActivityReset()),
    resetUpdate: () => dispatch(resetUpdate()),
    resetUpdateOrder: () => dispatch(resetUpdateOrder()),
    cancellationReason: (order, reason, unavailableDays) => dispatch(cancellationReason(order, reason, unavailableDays))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(showStyle)(injectIntl(Show)));
